// Footer Accordation default close js logic
document.addEventListener("DOMContentLoaded", function() {
    function isMobileDevice() {
        return window.innerWidth <= 749;
    }

    const detailsElements = document.querySelectorAll(".accordion-inner-wrapper");

    detailsElements.forEach(function(details) {
        if (isMobileDevice()) {
            details.removeAttribute("open");
        } else {
            details.setAttribute("open", "open");
        }
    });

    window.addEventListener("resize", function() {
        detailsElements.forEach(function(details) {
            if (isMobileDevice()) {
                details.removeAttribute("open");
            } else {
                details.setAttribute("open", "open");
            }
        });
    });
});


    // Smooth scroll functionality for anchor links
    function handleSmoothScroll(e, element) {
        const href = element.getAttribute('href');
        
        // Check if the link is an anchor link (starts with #)
        if (href && href.startsWith('#')) {
            e.preventDefault();
            
            const targetId = href.substring(1);
            const targetElement = document.getElementById(targetId);
            
            if (targetElement) {
                targetElement.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            }
        }
    }

    // Apply smooth scroll to collection cards
    const collectionCards = document.querySelectorAll('.scroll-button');
    collectionCards.forEach(card => {
        card.addEventListener('click', function(e) {
            handleSmoothScroll(e, this);
        });
    });


// Back to Top Button functionality
document.addEventListener("DOMContentLoaded", function() {
    const backToTopButton = document.querySelector('.back-to-top');
    
    if (!backToTopButton) return;

    // Show/hide button based on scroll position
    function toggleBackToTopButton() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const showThreshold = 300; // Show button after scrolling 300px
        
        if (scrollTop > showThreshold) {
            backToTopButton.classList.add('visible');
        } else {
            backToTopButton.classList.remove('visible');
        }
    }

    // Smooth scroll to top function
    function scrollToTop() {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }

    // Event listeners
    window.addEventListener('scroll', toggleBackToTopButton);
    backToTopButton.addEventListener('click', scrollToTop);

    // Initial check
    toggleBackToTopButton();
});


// =============================================
// PDP – Show More / Show Less Description
// =============================================
document.addEventListener('DOMContentLoaded', function () {
    function initPdpShowMore() {
        var buttons = document.querySelectorAll('.pdp-show-more-btn');

        buttons.forEach(function (btn) {
            var wrapper = btn.closest('.pdp-description-wrapper');
            if (!wrapper) return;

            var textEl = btn.querySelector('.pdp-show-more-btn__text');
            var showMoreText = btn.getAttribute('data-show-more-text') || 'Show more';
            var showLessText = btn.getAttribute('data-show-less-text') || 'Show less';

            btn.addEventListener('click', function () {
                var isExpanded = wrapper.classList.toggle('pdp-is-expanded');

                btn.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
                if (textEl) {
                    textEl.textContent = isExpanded ? showLessText : showMoreText;
                }
            });
        });
    }

    initPdpShowMore();
});